import React, { useEffect, useState } from 'react';

import { Button, Surface } from '@infoods/lifebase-ui';

import classes from './PaymentResult.module.scss';
import { ResultTitle } from '../../../../components/payment-result/ResultTitle/ResultTitle';
import { PaymentDetails } from '../../../../components/payment-result/PaymentDetails/PaymentDetails';
import { PaymentInfo } from '../../../../interfaces/paymentResult';
import { stripeService } from '../../../../services/stripeService';
import { goTo } from '../../../../../shared/utils/angularUtils';

type PaymentResultProps = {
  entityId: number;
  paymentIntentId: string;
};

const PaymentResult = ({ entityId, paymentIntentId }: PaymentResultProps) => {
  const [paymentInfo, setPaymentInfo] = useState<PaymentInfo | null>(null);

  const getPaymentInfo = async () => {
    const info = await stripeService.getSelfBillingPaymentResult(
      entityId,
      paymentIntentId,
    );
    setPaymentInfo(info);
  };

  useEffect(() => {
    getPaymentInfo();
  }, []);

  if (!paymentInfo) {
    return null;
  }

  return (
    <Surface className={classes.box}>
      <ResultTitle isSuccessful title="Thank you for your payment!" />
      <PaymentDetails paymentInfo={paymentInfo} />
      <Button
        variant="contained"
        size="medium"
        onClick={() => {
          goTo('/entity-dashboard', {
            replaceHistory: true,
          });
        }}
      >
        Go to Dashboard
      </Button>
    </Surface>
  );
};

export { PaymentResult };
